import { render } from "./CategoryView.vue?vue&type=template&id=8e9ef5ca&scoped=true"
import script from "./CategoryView.vue?vue&type=script&lang=js"
export * from "./CategoryView.vue?vue&type=script&lang=js"

import "./CategoryView.vue?vue&type=style&index=0&id=8e9ef5ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e9ef5ca"]])

export default __exports__